import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavigationContext from "../contexts/NavigationContext";
import { useAddBookMutation } from "../features/api/apiSlice";

export default function AddBook() {
	const [addBook, { isSuccess, isError }] = useAddBookMutation();
	const navigate = useNavigate();
	const { setNavTab } = useContext(NavigationContext);
	
	const [name, setName] = useState("");
	const [author, setAuthor] = useState("");
	const [thumbnail, setThumbnail] = useState('');
	const [price, setPrice] = useState('');
	const [rating, setRating] = useState('');
	const [featured, setFeatured] = useState(false);

	useEffect(() => {
		if (isSuccess) {
			navigate("/");
			setNavTab("BookStore");
		}
	}, [isSuccess, navigate, setNavTab]);

	const handleFormSubmit = (e) => {
		e.preventDefault();

		const data = {
			name,
			author,
			thumbnail,
			price: Number(price),
			rating: Number(rating),
			featured
		};
		addBook(data);

	};

	return (
		<main className="py-6 2xl:px-6">
			<div className="container">
				<div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
					<h4 className="mb-8 text-xl font-bold text-center">
						Add New Book
					</h4>
					<form onSubmit={handleFormSubmit} className="book-form">
						<div className="space-y-2">
							<label htmlFor="lws-bookName">Book Name</label>
							<input
								value={name}
								onChange={(e) => setName(e.target.value)}
								required
								className="text-input"
								type="text"
								id="lws-bookName"
								name="name"
							/>
						</div>

						<div className="space-y-2">
							<label htmlFor="lws-author">Author</label>
							<input
								value={author}
								onChange={(e) => setAuthor(e.target.value)}
								required
								className="text-input"
								type="text"
								id="lws-author"
								name="author"
							/>
						</div>

						<div className="space-y-2">
							<label htmlFor="lws-thumbnail">Image Url</label>
							<input
								value={thumbnail}
								onChange={(e) => setThumbnail(e.target.value)}
								required
								className="text-input"
								type="text"
								id="lws-thumbnail"
								name="thumbnail"
							/>
						</div>

						<div className="grid grid-cols-2 gap-8 pb-4">
							<div className="space-y-2">
								<label htmlFor="lws-price">Price</label>
								<input
									value={price}
									onChange={(e) => setPrice(e.target.value)}
									required
									className="text-input"
									type="number"
									id="lws-price"
									name="price"
								/>
							</div>

							<div className="space-y-2">
								<label htmlFor="lws-rating">Rating</label>
								<input
									value={rating}
									onChange={(e) => setRating(e.target.value)}
									required
									className="text-input"
									type="number"
									id="lws-rating"
									name="rating"
									min="1"
									max="5"
								/>
							</div>
						</div>

						<div className="flex items-center">
							<input
								checked={featured}
								onChange={() => setFeatured(!featured)}
								id="lws-featured"
								type="checkbox"
								name="featured"
								className="w-4 h-4"
							/>
							<label htmlFor="lws-featured" className="ml-2 text-sm">
								{" "}
								This is a featured book{" "}
							</label>
						</div>

						<button type="submit" className="submit" id="lws-submit">
							Add Book
						</button>
					</form>

					{isError && <p className="error">There was an error creating the book</p>}
				</div>
			</div>
		</main>
	);
}
